import { FC } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';
import { ListenerActions, usePostMessageListener } from '@bizzabo/dev-platform-client-sdk';
import { UserData } from '@bizzabo/entities';
import { parseUrl, extractOriginFromUrl } from '../../utils/helpers';

type Props = {
    appExtensionUrl: string;
    appExtensionClientId: string;
    accountId: number;
    eventId: number;
    sessionId?: number;
    user?: UserData;
    openModal?: (data: unknown) => void;
    openNewTab?: (data: unknown) => void;
};

const AppFrame: FC<Props> = ({
    appExtensionUrl,
    appExtensionClientId,
    accountId,
    eventId,
    sessionId,
    user,
    openModal,
    openNewTab,
}) => {
    const classes = useStyles();

    const urlWithQueryParams = appExtensionUrl
        ? parseUrl(appExtensionUrl, accountId, eventId, sessionId, user)
        : '';

    const appOrigin = extractOriginFromUrl(appExtensionUrl);

    usePostMessageListener(
        [appOrigin],
        appExtensionClientId,
        ListenerActions.APP_EXT_OPEN_MODAL,
        openModal
    );

    usePostMessageListener(
        [appOrigin],
        appExtensionClientId,
        ListenerActions.APP_EXT_OPEN_LINK_NEW_TAB,
        openNewTab
    );

    return (
        <iframe
            src={urlWithQueryParams}
            className={classes.frame}
            sandbox="allow-forms allow-scripts allow-same-origin"
        />
    );
};

const useStyles = makeStyles<Theme>(
    () => ({
        frame: {
            height: '100%',
            width: '100%',
            border: 'none',
            borderBottomLeftRadius: 33,
            borderBottomRightRadius: 33,
        },
    }),
    {
        classNamePrefix: 'AppFrame',
    }
);

export default AppFrame;
